import { CHAT_SUPERVISION_REDIRECT } from './pages/asignarcoordinar/supervision-links';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth/auth.guard';
import { TipoTrabajoGuard } from './guards/tipo-trabajo/tipo-trabajo.guard';
import { RoleGuard } from './guards/role/role.guard';
import { DocumentoGuard } from './guards/documento/documento.guard';
import { VisorArchivoComponent } from './pages/manual/visor-archivo/VisorArchivoComponent';
import { TableroDetalleComponent } from './pages/tareas/tablero-detalle/tablero-detalle.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'leads',
        loadChildren: () =>
          import(
            './pages/clienteresidencial/clienteResidencialComponent.module'
          ).then((m) => m.ClienteResidencialComponentModule),
        data: { animation: 'ClienteResidencialPage' },
      },
      CHAT_SUPERVISION_REDIRECT,
      {
        path: 'coordinador',
        loadChildren: () =>
          import('./pages/asignarcoordinar/asignarcoordinar.module').then(
            (m) => m.AsignarcoordinarModule
          ),
        data: { animation: 'CoordinadorPage' },
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
        data: { animation: 'AuthPage' },
      },
      {
        path: 'static',
        loadChildren: () =>
          import('./pages/static/static.module').then((m) => m.StaticModule),
        data: { animation: 'StaticPage' },
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
        data: { animation: 'HomePage' },
      },
      {
        path: 'ventas',
        loadChildren: () =>
          import('./pages/ventas/ventas.module').then((m) => m.VentasModule),
        data: { animation: 'VentasPage' },
      },
      {
        path: 'excel-module',
        loadChildren: () =>
          import('./pages/excel-module/excel-module.module').then((m) => m.ExcelModuleModule),
        canActivate: [AuthGuard],
        data: {
          animation: 'ExcelModulePage',
          tipoTrabajo: ['Excel'] // Solo usuarios con tipoTrabajo = "Excel"
        },
      },
      {
        path: 'excel-tipificaciones',
        loadChildren: () =>
          import('./pages/excel-tipificaciones/excel-tipificaciones.module').then((m) => m.ExcelTipificacionesModule),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          animation: 'ExcelTipificacionesPage',
          roles: ['ADMIN', 'PROGRAMADOR', 'LECTOR', 'COORDINADOR'] // Administradores, supervisores y coordinadores (metricas de bases)
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'anuncios',
        loadChildren: () =>
          import('./pages/anuncios/anuncios.module').then(
            (m) => m.AnunciosModule
          ),
        data: { animation: 'AnunciosPage' },
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./pages/calendar/calendar.module').then(
            (m) => m.CalendarModule
          ),
        data: { animation: 'CalendarPage' },
      },
      {
        path: 'manual',
        loadChildren: () =>
          import('./pages/manual/manual.module').then((m) => m.ManualModule),
        data: { animation: 'ManualPage' },
      },
      {
        path: 'ipsPermitidas',
        loadChildren: () =>
          import('./pages/ip-permitidas/ip-permitidas.module').then(
            (m) => m.IpPermitidasModule
          ),
        canActivate: [AuthGuard],
        data: {
          animation: 'IpsPermitidasPage',
          roles: ['ADMIN'], // Asegura que solo ADMIN puede acceder
        },
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./pages/faq/FaqModule').then((m) => m.FaqModule),
        canActivate: [AuthGuard],
        data: { animation: 'FaqPage' },
      },
      {
        path: 'landing-contact',
        loadChildren: () =>
          import('./pages/landing-contact/landing-contact.module').then(
            (m) => m.LandingContactModule
          ),
        canActivate: [AuthGuard],
        data: { animation: 'LandingContactPage' },
      },
      {
        path: 'sede',
        loadChildren: () =>
          import('./pages/sede/sede.module').then((m) => m.SedeModule),
        canActivate: [AuthGuard],
        data: { animation: 'SedePage' },
      },
      {
        path: 'reportes-mensuales',
        loadChildren: () =>
          import('./pages/reportes-mensuales/reportes-mensuales.module').then(
            (m) => m.ReportesMensualesModule
          ),
        canActivate: [AuthGuard],
        data: { animation: 'ReportesMensualesPage' },
      },
      {
        path: 'analisis-transcripcion',
        loadChildren: () =>
          import(
            './pages/analisis-transcripcion/analisis-transcripcion.module'
          ).then((m) => m.AnalisisTranscripcionModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'asistencias',
        loadChildren: () =>
          import('./pages/asistencias/asistencias.module').then(
            (m) => m.AsistenciasModule
          ),
        canActivate: [AuthGuard],
        data: { animation: 'AsistenciasPage' },
      },
      {
        path: 'promociones',
        loadChildren: () =>
          import('./pages/promociones/promociones.module').then(
            (m) => m.PromocionesModule
          ),
        canActivate: [AuthGuard],
        data: {
          animation: 'PromocionesPage',
          roles: ['ADMIN', 'LECTOR', 'PROGRAMADOR', 'MARKETING'], // Solo roles administrativos
        },
      },

      {
        path: 'correos',
        loadChildren: () =>
          import('./pages/correos/correos.module').then((m) => m.CorreosModule),
        canActivate: [AuthGuard],
        data: { animation: 'CorreosPage' },
      },
      {
        path: 'archivos',
        loadChildren: () =>
          import('./pages/archivos/archivos.module').then(
            (m) => m.ArchivosModule
          ),
        canActivate: [AuthGuard],
        data: { animation: 'ArchivosPage' },
      },
      {
        path: 'spreadsheet',
        loadChildren: () =>
          import('./pages/spreadsheet/spreadsheet.module').then(
            (m) => m.SpreadsheetModule
          ),
        canActivate: [AuthGuard],
        data: { animation: 'SpreadsheetPage' },
      },

    ],
  },
  {
    path: 'landing-contact',
    loadChildren: () =>
      import('./pages/landing-contact/landing-contact.module').then(
        (m) => m.LandingContactModule
      ),
  },
  {
    path: 'coaching',
    loadChildren: () =>
      import('./pages/coaching/coaching.module').then((m) => m.CoachingModule),
  },
  { path: 'tablero/:id', component: TableroDetalleComponent },
  {
    path: 'coaching-dashboard',
    loadChildren: () =>
      import('./pages/coaching-dashboard/coaching-dashboard.module').then(
        (m) => m.CoachingDashboardModule
      ),
  },
  {
    path: 'sede',
    loadChildren: () =>
      import('./pages/sede/sede.module').then((m) => m.SedeModule),
  },
  {
    path: 'cursos',
    loadChildren: () =>
      import('./pages/cursos/cursos.module').then((m) => m.CursosModule),
  },
  {
    path: 'postulacion',
    loadChildren: () =>
      import('./pages/postulacion/postulacion.module').then(
        (m) => m.PostulacionModule
      ),
  },
  {
    path: 'mapas',
    loadChildren: () =>
      import('./pages/mapas/mapas.module').then((m) => m.MapasModule),
    data: { animation: 'MapasPage' },
  },
  {
    path: 'encuestas',
    loadChildren: () =>
      import('./pages/encuestas/encuestas.module').then(
        (m) => m.EncuestasModule
      ),
    canActivate: [AuthGuard],
    data: { animation: 'EncuestasPage' },
  },
  {
    path: 'tareas',
    loadChildren: () =>
      import('./pages/tareas/tareas.module').then((m) => m.TareasModule),
    canActivate: [AuthGuard],
    data: { animation: 'TareasPage' },
  },
  {
    path: 'tareas_v2',
    loadChildren: () =>
      import('./pages/boards/board.module').then((m) => m.BoardsModule),
    canActivate: [AuthGuard],
    data: { animation: 'TareasPage' },
  },
  {
    path: 'tareas-asesor',
    loadChildren: () =>
      import('./pages/tareas-asesor/tareas-asesor.module').then(
        (m) => m.TareasAsesorModule
      ),
  },
  {
    path: 'notificaciones',
    loadChildren: () =>
      import('./pages/notificaciones/notificaciones.module').then(
        (m) => m.NotificacionesModule
      ),
    canActivate: [AuthGuard],
    data: { animation: 'NotificacionesPage' },
  },
  {
    path: 'certificados',
    loadChildren: () =>
      import('./pages/certificados/certificados.module').then(
        (m) => m.CertificadosModule
      ),
    canActivate: [AuthGuard],
    data: {
      animation: 'CertificadosPage',
      roles: ['ADMIN'], // Solo administradores pueden acceder
    },
  },
  {
    path: 'visor-archivo',
    component: VisorArchivoComponent,
  },
  {
    path: 'logs-excel-masivos',
    loadChildren: () =>
      import('./pages/logs-excel-masivos/logs-excel-masivos.module').then(
        (m) => m.LogsExcelMasivosModule
      ),
    canActivate: [AuthGuard],
    data: {
      animation: 'LogsExcelMasivosPage',
      roles: ['ADMIN'], // Solo administradores pueden acceder
    },
  },
  {
    path: 'horario-conserjes',
    loadChildren: () =>
      import('./pages/horario-conserjes/horario-conserjes.module').then(
        (m) => m.HorarioConserjesModule
      ),
    canActivate: [AuthGuard],
    data: {
      animation: 'HorarioConserjesPage',
      title: 'Horario Conserjes'
    },
  },
  {
    path: 'logs-ventas',
    loadChildren: () =>
      import('./pages/logs-ventas/logs-ventas.module').then(
        (m) => m.LogsVentasModule
      ),
    canActivate: [AuthGuard, DocumentoGuard],
    data: {
      animation: 'LogsVentasPage',
      title: 'Logs Ventas',
      usernames: ['72640568', '73635487', 'josetorchi'] // Usernames específicos permitidos
    },
  },
  {
    path: 'auditoria-logins', redirectTo: 'logs-generales', pathMatch: 'full',
  },
  {
    path: 'logs-generales',
    loadChildren: () => import('./pages/logs-generales/logs-generales.module').then(m => m.LogsGeneralesModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { title: 'Logs generales', roles: ['ADMIN', 'SUPERADMIN', 'PROGRAMADOR'] },
  },
  
  {
    path: 'dashboard-supervisor',
    loadChildren: () =>
      import('./pages/dashboard-supervisor/dashboard-supervisor.module').then(
        (m) => m.DashboardSupervisorModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      animation: 'DashboardSupervisorPage',
      roles: ['ADMIN', 'PROGRAMADOR'], // Solo ADMIN y PROGRAMADOR
    },
  },
   {
	    path: 'dashboard-comercial',
	    loadChildren: () =>
	      import('./pages/dashboard-comercial/dashboard-comercial.module').then(
	        (m) => m.DashboardComercialModule
	      ),
	    canActivate: [AuthGuard, RoleGuard],
	    data: {
	      animation: 'DashboardComercialPage',
	      roles: ['ADMIN', 'PROGRAMADOR'], // TODO: confirmar roles para Comercial
	    },
	  },
  { path: 'dashboard-backoffice', loadChildren: () => import('./pages/dashboard-backoffice/dashboard-backoffice.module').then(m => m.DashboardBackofficeModule) },
  { path: 'dashboard-backoffice-ind', loadChildren: () => import('./pages/dashboard-backoffice-ind/dashboard-backoffice.module').then(m => m.DashboardBackofficeModule) },
{
    path: 'dashboard-reporte-general',
    loadChildren: () =>
      import('./pages/dashboard-reporte-general/dashboard-reporte-general.module').then(
        (m) => m.DashboardReporteGeneralModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      animation: 'DashboardReporteGeneralPage',
      roles: ['ADMIN', 'PROGRAMADOR'],
    },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'static/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
